import React from 'react'

import { useParams, useNavigate } from 'react-router-dom'

import { useDate } from '@hooks/dates'
import { useFindTask } from '@hooks/task/find'

import { TaskPills } from '../Pills'
import { BoldText, LabelValueHeader, RegularText } from './styles'

export function MidstreamData() {
  const { taskId } = useParams<{ taskId: string }>()

  const { formatDate } = useDate()

  const { data: rawTask } = useFindTask(Number(taskId))

  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  return (
    <>
      <BoldText>{task.code}</BoldText>
      <BoldText>{task.name}</BoldText>

      <TaskPills />

      <LabelValueHeader>
        <RegularText>LACD </RegularText>
        <BoldText>
          {task.lastAvailableCompletionDate &&
            formatDate(new Date(task.lastAvailableCompletionDate)).dateShort}
        </BoldText>
      </LabelValueHeader>

      <LabelValueHeader>
        <RegularText>Start Date </RegularText>
        <BoldText>{formatDate(new Date(task.startTime)).dateShort}</BoldText>
      </LabelValueHeader>

      <LabelValueHeader>
        <RegularText>Is Break-in? </RegularText>
        <BoldText>{task.isBreakIn ? 'YES' : 'NO'}</BoldText>
      </LabelValueHeader>
    </>
  )
}
